import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useWholesale } from '../contexts/WholesaleContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const WholesaleLoginPage = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useWholesale();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/wholesale/dashboard');
    }
  }, [isAuthenticated, navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login(formData.email, formData.password);
      navigate('/wholesale/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="paper-texture min-h-screen py-12">
      <div className="max-w-md mx-auto px-6">
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl mb-4">Wholesale Portal</h1>
          <p className="text-[#8C8885]">Login to access wholesale pricing and ordering</p>
        </div>

        <div className="bg-white border border-alt-bg p-8 soft-shadow">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="p-4 bg-red-50 border border-red-200 text-red-700 text-sm">
                {error}
              </div>
            )}

            <div>
              <Label htmlFor="email" className="text-sm font-semibold uppercase tracking-wider mb-2">
                Email
              </Label>
              <Input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                className="w-full"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-sm font-semibold uppercase tracking-wider mb-2">
                Password
              </Label>
              <Input
                id="password"
                name="password"
                type="password"
                required
                value={formData.password}
                onChange={handleInputChange}
                className="w-full"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-cape-red hover:bg-red-800 text-white py-3"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-[#8C8885] text-sm">
              Don&apos;t have an account?{' '}
              <Link to="/wholesale/register" className="text-cape-red hover:underline">
                Register here
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-[#8C8885] text-sm hover:underline">
            ← Back to retail store
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WholesaleLoginPage;
